export interface Project {
  slug: string;
  name: string;
  type: string;
  description: string;
  tech: string[];
  github?: string;
  demo?: string;
  private?: boolean;
  screenshots?: string[];
}

export const projects: Project[] = [
  {
    slug: 'selah',
    name: 'Selah',
    type: 'desktop app',
    description:
      'Bible reader for pausing, reflecting, and studying the Word. Distraction-free reading across multiple translations, verse highlighting and tagging, a prayer journal, Bible quizzes, reading streaks, and studying with friends.',
    tech: ['JavaScript', 'Electron', 'Express', 'SQLite'],
    private: true,
    screenshots: [
      '/screenshots/selah-reader.webp',
      '/screenshots/selah-study.webp',
      '/screenshots/selah-landing.webp',
    ],
  },
  {
    slug: 'unified',
    name: 'Unified',
    type: 'mobile app',
    description:
      'iOS and Android app allowing community members to report local incidents to HOA and city officials. Reduced area crime and improved response times since deployment.',
    tech: ['React Native', 'Expo', 'JavaScript', 'PostgreSQL', 'Supabase'],
    private: true,
  },
  {
    slug: 'stall-stars',
    name: 'Stall Stars',
    type: 'mobile app',
    description:
      'iOS and Android app for finding, rating, and reviewing public restrooms. Features an interactive map, amenity filters, OTP authentication, and a full review system with cleanliness, entry, and features scoring.',
    tech: ['TypeScript', 'Go', 'React Native', 'Expo', 'PostgreSQL', 'Neon', 'Render'],
    private: true,
  },
  {
    slug: 'stewordle',
    name: 'Stewordle',
    type: 'web game',
    description:
      'Word puzzle with 4 modes — Classic, Quad, Octo, and 16. Unlimited plays, no daily wait.',
    tech: ['JavaScript', 'HTML', 'CSS'],
    demo: 'https://www.stewdioben.com/stewordle/',
    private: true,
    screenshots: [
      '/screenshots/stewordle-play.webp',
      '/screenshots/stewordle-16.webp',
    ],
  },
  {
    slug: 'griddy',
    name: 'Griddy',
    type: 'web game',
    description:
      'Daily NFL player grid — pick a player that satisfies two intersecting team and college parameters. Nine squares, nine chances.',
    tech: ['React', 'JavaScript', 'Node.js'],
    demo: 'https://www.stewdioben.com/griddy',
    private: true,
    screenshots: [
      '/screenshots/griddy-filled.webp',
      '/screenshots/griddy-search.webp',
    ],
  },
  {
    slug: 'speakeasy',
    name: 'Speakeasy',
    type: 'mobile app',
    description:
      'Audio-only messaging app for iOS and Android with real-time vocal effects — pitch bending, reverse, and more — to bring personality back to conversations.',
    tech: ['TypeScript', 'Go', 'React Native', 'Expo', 'Gin', 'PostgreSQL', 'AWS'],
    private: true,
  },
  {
    slug: 'hash-cli',
    name: 'Hash CLI',
    type: 'cli tool',
    description:
      'CLI tool for symmetric file encryption and decryption with passphrase-based MAC authentication, KMAC hashing, and elliptic curve operations.',
    tech: ['Java'],
    github: 'https://github.com/benjuh/cryptography-project',
  },
  {
    slug: 'stew',
    name: 'Stew',
    type: 'cli tool',
    description:
      'Go CLI tool for creating, storing, and applying project templates — eliminating boilerplate setup for any language or framework.',
    tech: ['Go', 'Cobra', 'Viper'],
    github: 'https://github.com/benjuh/stew',
  },
];
